// extracted by mini-css-extract-plugin
export default {"genericCard":"ss-z","inline":"ts-z","mastercard":"us-z","discover":"vs-z","visa":"ws-z","amex":"xs-z","active":"ys-z"};